var _defs, _defs2, _defs3, _defs4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContributor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 18.888,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.054,
    y: 396.75,
    style: {
      fill: "#EBEBEB"
    },
    width: 29.473,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.667,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 47.111,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 10.971,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.333,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 38.555,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 54.147,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 18.888,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.054,
    y: 396.75,
    style: {
      fill: "#EBEBEB"
    },
    width: 29.473,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.667,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 47.111,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 10.971,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.333,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 38.555,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 54.147,
    height: 0.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 137.558,
    y: 85.619,
    style: {
      fill: "#E6E6E6"
    },
    width: 59.38,
    height: 135.039
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.186,
    y: 85.619,
    style: {
      fill: "#F5F5F5"
    },
    width: 59.38,
    height: 135.039
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.437,
    y: 129.961,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 324.015 -17.7371)",
    style: {
      fill: "#FFFFFF"
    },
    width: 122.879,
    height: 46.357
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.244,
    y: 151.768,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 345.8221 -39.5442)",
    style: {
      fill: "#E6E6E6"
    },
    width: 122.879,
    height: 2.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.879,
    y: 178.089,
    style: {
      fill: "#F5F5F5"
    },
    width: 53.993,
    height: 8.163
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.879,
    y: 102.418,
    style: {
      fill: "#F5F5F5"
    },
    width: 53.993,
    height: 8.163
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.617,
    y: 85.619,
    style: {
      fill: "#E6E6E6"
    },
    width: 59.38,
    height: 135.039
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.245,
    y: 85.619,
    style: {
      fill: "#F5F5F5"
    },
    width: 59.38,
    height: 135.039
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.496,
    y: 129.961,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 404.074 -97.7961)",
    style: {
      fill: "#FFFFFF"
    },
    width: 122.879,
    height: 46.357
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.303,
    y: 151.768,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 425.881 -119.6031)",
    style: {
      fill: "#E6E6E6"
    },
    width: 122.879,
    height: 2.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.938,
    y: 178.089,
    style: {
      fill: "#F5F5F5"
    },
    width: 53.993,
    height: 8.163
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.938,
    y: 102.418,
    style: {
      fill: "#F5F5F5"
    },
    width: 53.993,
    height: 8.163
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57.499,
    y: 85.619,
    style: {
      fill: "#E6E6E6"
    },
    width: 59.38,
    height: 135.039
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.127,
    y: 85.619,
    style: {
      fill: "#F5F5F5"
    },
    width: 59.38,
    height: 135.039
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.378,
    y: 129.961,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 243.9559 62.322)",
    style: {
      fill: "#FFFFFF"
    },
    width: 122.879,
    height: 46.357
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.185,
    y: 151.768,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 265.7629 40.5149)",
    style: {
      fill: "#E6E6E6"
    },
    width: 122.879,
    height: 2.743
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.82,
    y: 178.089,
    style: {
      fill: "#F5F5F5"
    },
    width: 53.993,
    height: 8.163
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.82,
    y: 102.418,
    style: {
      fill: "#F5F5F5"
    },
    width: 53.993,
    height: 8.163
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 319.51,
    y: 247.505,
    style: {
      fill: "#E6E6E6"
    },
    width: 9.709,
    height: 134.892
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.099,
    y: 247.505,
    style: {
      fill: "#F0F0F0"
    },
    width: 5.719,
    height: 134.892
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.706,
    y: 247.505,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 529.295 505.1284)",
    style: {
      fill: "#F0F0F0"
    },
    width: 137.883,
    height: 10.118
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.404,
    y: 247.505,
    style: {
      fill: "#E6E6E6"
    },
    width: 9.709,
    height: 134.892
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.215,
    y: 247.505,
    style: {
      fill: "#F0F0F0"
    },
    width: 5.719,
    height: 134.892
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.669,
    y: 247.505,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 245.2206 505.1284)",
    style: {
      fill: "#E6E6E6"
    },
    width: 137.883,
    height: 10.118
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.17,
    y: 247.505,
    style: {
      fill: "#E6E6E6"
    },
    width: 9.709,
    height: 134.892
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.759,
    y: 247.505,
    style: {
      fill: "#F0F0F0"
    },
    width: 5.719,
    height: 134.892
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "170.174,202.639 242.169,202.639 247.823,245.153 175.827,245.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "175.827,245.153 176.118,247.503 248.118,247.503 247.827,245.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "172.39,202.639 244.385,202.639 250.039,245.153 178.043,245.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "179.785,243.211 174.648,204.581 242.643,204.581 247.781,243.211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "196.803,245.153 197.094,247.503 276.376,247.503 276.085,245.153  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M326.905,211h-35.641c-12.69,0-23.163,9.125-24.822,21.627l-5.217,39.32l-19.352-0.064h-0.061 c-9.222,0-16.445,6.554-17.209,15.615l-1.14,13.462c-3.833,0.561-6.854,3.533-7.376,7.47h95.611 c12.677,0,23.141-9.117,24.798-21.607l7.491-56.461C345.329,220.253,337.165,211,326.905,211z M242.874,300.855h-14.3 l1.074-12.412c0.566-6.675,5.907-11.527,12.703-11.527h0.05l18.158,0.06l-1.271,9.578 C258.191,294.821,251.265,300.855,242.874,300.855z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "238.172,308.429 233.211,308.429 221.586,382.398 226.547,382.398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256.788,308.429 251.827,308.429 240.202,382.398 245.163,382.398  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "300.471,308.429 305.432,308.429 317.057,382.398 312.096,382.398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "281.855,308.429 286.816,308.429 298.441,382.398 293.48,382.398  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 342.922,
    y: 87.988,
    style: {
      fill: "#E6E6E6"
    },
    width: 96.691,
    height: 202.012
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.707,
    y: 87.988,
    style: {
      fill: "#F0F0F0"
    },
    width: 101.624,
    height: 202.012
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.027,
    y: 146.696,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 584.5132 -206.5249)",
    style: {
      fill: "#FAFAFA"
    },
    width: 184.985,
    height: 84.596
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "383.209,281.487 393.69,96.502 407.829,96.502 397.348,281.487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "400.021,281.487 410.502,96.502 424.642,96.502 414.16,281.487  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M89.699,163.746c-9.438,61.268,24.99,128.337,71.841,166.757 c65.154,53.43,136.535,67.363,176.688,2.135c38.794-63.021,7.363-100.696-65.033-154.217 C203.921,127.208,101.205,89.055,89.699,163.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M89.699,163.746c-9.438,61.268,24.99,128.337,71.841,166.757 c65.154,53.43,136.535,67.363,176.688,2.135c38.794-63.021,7.363-100.696-65.033-154.217 C203.921,127.208,101.205,89.055,89.699,163.746z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__205_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "People"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "240.809,121.599 225.303,348.088 414.418,348.088 431.549,97.869 266.173,97.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    points: "240.809,121.599 225.303,348.088 414.418,348.088 431.549,97.869  266.173,97.869  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7191 -0.6949 0.6949 0.7191 0.0319 305.6825)",
    style: {
      fill: "#407BFF"
    },
    cx: 378.127,
    cy: 152.802,
    rx: 32.082,
    ry: 29.96
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    transform: "matrix(0.7191 -0.6949 0.6949 0.7191 0.0328 305.6847)",
    cx: 378.127,
    cy: 152.802,
    rx: 30.394,
    ry: 28.383
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043421856110617682700000012063227603505289651_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000043421856110617682700000012063227603505289651_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M370.415,163.029l-5.784-0.382c0,0-2.689,13.841-4.414,15.036 c-2.347,1.627-7.002,5.565-10.083,6.993c-0.267,0.622-0.456,2.378-0.196,2.915c4.803,0.026,13.679-4.777,15.216-6.857 C368.658,175.99,370.415,163.029,370.415,163.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M373.168,154.322c1.749,3.259-3.699,15.037-3.699,15.037l-7.423-2.37 c0,0,0.264-5.863,2.476-10.476C366.357,152.686,371.249,150.745,373.168,154.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M367.499,160.325c1.028,2.353-0.311,8.055-1.343,11.665 C363.646,167.689,363.302,163.691,367.499,160.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M367.466,154.9c-1.14,4.169-3.374,15.119-1.545,32.308h19.532 c0.451-3.272-0.121-19.233,4.468-34.65c0,0-3.585-0.733-7.051-0.901c-2.711-0.131-6.646-0.218-9.061,0 c-1.462,0.132-2.794,0.425-3.808,0.702C368.774,152.696,367.801,153.674,367.466,154.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M384.937,156.364c-0.591,2.537-0.355,8.608,1.409,15.622c0.51-5.399,1.416-11.658,3.136-17.895 l0.003-0.03C388.095,153.918,385.498,153.986,384.937,156.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M382.474,143.183c-0.843,2.915-1.462,6.529,0.396,8.474c0,0-1.447,2.957-6.864,2.957 c-4.95,0-2.197-2.957-2.197-2.957c3.323-0.776,3.527-4.797,3.172-7.062L382.474,143.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M376.006,154.614c0.858,1.454,0.779,2.8,0.779,2.8s7.007-2.393,7.016-5.9 c0,0-0.91-0.572-1.478-1.036C382.323,150.478,381.848,153.21,376.006,154.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M375.811,154.613c-1.129,1.454-1.377,2.591-1.377,2.591s-2.88-2.08-1.635-5.546 c0,0,0.901-0.363,1.788-0.552C374.587,151.105,373.741,153.862,375.811,154.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M376.978,144.598c0.214,1.327,0.23,3.258-0.467,4.786c0.485-0.071,0.988-0.217,1.494-0.446 c1.913-0.865,2.943-2.224,4.071-4.242c0.119-0.517,0.253-1.023,0.396-1.512L376.978,144.598z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M372.25,141.898c0.307,0.993,1.056,1.709,1.835,2.04c1.171,0.498,2.023-0.563,1.921-1.799 c-0.091-1.112-0.81-2.712-2.093-2.684C372.649,139.482,371.899,140.762,372.25,141.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M372.25,141.898c0.307,0.993,1.056,1.709,1.835,2.04c1.171,0.498,2.023-0.563,1.921-1.799 c-0.091-1.112-0.81-2.712-2.093-2.684C372.649,139.482,371.899,140.762,372.25,141.898z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M377.477,133.733c-0.377-2.314-3.784,1.745-3.058,3.889 C375.145,139.766,377.901,136.331,377.477,133.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M384.78,139.588c-1.253,3.867-1.795,6.177-4.244,7.846c-3.683,2.51-7.923-0.104-7.816-4.165 c0.096-3.655,2.129-9.365,6.266-10.267C383.063,132.113,386.033,135.721,384.78,139.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M383.64,137.298c-4.222-0.598-10.28-1.374-8.084-4.824c2.095-3.291,10.431-2.693,7.9-1.234 c3.278,0.187,7.434,1.758,4.293,2.842c2.532,1.795,1.529,6.619-3.298,8.302C383.056,140.365,381.959,139.467,383.64,137.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M385.38,144.198c-0.775,0.804-1.816,1.206-2.691,1.247c-1.317,0.062-1.566-1.192-0.857-2.286 c0.638-0.985,2.092-2.204,3.248-1.748C386.219,141.859,386.266,143.279,385.38,144.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M378.712,139.667c-0.083,0.318-0.315,0.547-0.518,0.512c-0.203-0.035-0.3-0.322-0.217-0.641 c0.083-0.318,0.315-0.547,0.518-0.512C378.698,139.062,378.795,139.349,378.712,139.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M375.203,139.053c-0.083,0.318-0.315,0.547-0.518,0.512c-0.203-0.036-0.3-0.322-0.217-0.641 c0.083-0.318,0.315-0.547,0.518-0.512C375.189,138.448,375.286,138.734,375.203,139.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED847E"
    },
    d: "M376.277,139.406c0,0-1.184,1.712-2.192,2.462c0.412,0.622,1.409,0.545,1.409,0.545 L376.277,139.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M376.169,143.451c-0.05-0.009-0.08-0.058-0.067-0.109c0.013-0.051,0.065-0.086,0.116-0.077 c1.363,0.239,2.253-0.626,2.262-0.634c0.039-0.038,0.099-0.041,0.133-0.005c0.035,0.035,0.032,0.095-0.007,0.134 C378.567,142.797,377.63,143.706,376.169,143.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M380.072,138.693c-0.055-0.01-0.103-0.045-0.126-0.1c-0.318-0.751-0.999-0.828-1.005-0.828 c-0.097-0.006-0.169-0.103-0.15-0.207c0.02-0.104,0.119-0.18,0.221-0.17c0.036,0.003,0.889,0.099,1.283,1.031 c0.039,0.093-0.007,0.208-0.103,0.256C380.152,138.694,380.11,138.699,380.072,138.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M373.959,137.502c-0.026-0.006-0.051-0.019-0.072-0.038c-0.074-0.066-0.075-0.185-0.002-0.267 c0.732-0.812,1.587-0.728,1.624-0.725c0.1,0.007,0.168,0.104,0.148,0.209c-0.021,0.104-0.119,0.179-0.221,0.168l0,0 c-0.029-0.003-0.697-0.061-1.281,0.587C374.102,137.495,374.025,137.518,373.959,137.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M391.645,157.913l-5.296,2.803c0,0,5.112,12.606,4.24,14.497 c-1.186,2.574-3.155,8.252-5.094,11.061c0.101,0.645,0.883,2.162,1.402,2.455c4.24-2.562,9.455-11.208,9.684-13.712 C397.102,169.308,391.645,157.913,391.645,157.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M389.921,152.558c3.695,0.656,6.414,13.83,6.414,13.83l-9.119,2.611 c0,0-2.049-4.677-3.203-9.335C382.803,154.782,385.959,151.854,389.921,152.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC3BD"
    },
    d: "M387.405,185.802l-3.769-0.275l1.628,4.182c0,0,3.313,0.13,4.092-2.41L387.405,185.802z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC3BD"
    },
    points: "380.384,187.452 382.052,191.151 385.264,189.71 383.636,185.528  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7191 -0.6949 0.6949 0.7191 -104.9806 340.0003)",
    style: {
      fill: "#407BFF"
    },
    cx: 368.059,
    cy: 299.852,
    rx: 32.082,
    ry: 29.96
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_00000175290521233508799050000001093678813002750080_",
    transform: "matrix(0.7191 -0.6949 0.6949 0.7191 -104.9812 339.9919)",
    cx: 368.059,
    cy: 299.852,
    rx: 30.394,
    ry: 28.383
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175290521233508799050000001093678813002750080_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002380720872322984140000018189015774751690649_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175290521233508799050000001093678813002750080_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000002380720872322984140000018189015774751690649_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M357.84,310.342l-5.427-1.769c0,0-5.911,13.015-7.846,13.78 c-2.633,1.041-8.026,3.808-11.311,4.477c-0.405,0.549-1.01,2.237-0.891,2.83c4.577,1.181,14.207-1.424,16.176-3.108 C353.031,322.714,357.84,310.342,357.84,310.342z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M362.572,302.41c0.881,3.638-7.164,13.953-7.164,13.953l-6.51-4.125 c0,0,1.669-5.724,4.895-9.745C356.469,299.157,361.605,298.418,362.572,302.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M362.572,302.41c0.881,3.638-7.164,13.953-7.164,13.953l-6.51-4.125 c0,0,1.669-5.724,4.895-9.745C356.469,299.157,361.605,298.418,362.572,302.41z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M357.494,306.942c0.607,2.519,0.056,6.543-1.555,9.972 C354.515,314.77,352.84,309.598,357.494,306.942z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M357.399,301.949c-1.14,4.169-3.374,15.119-1.545,32.308h19.532 c0.451-3.272-0.121-19.233,4.468-34.65c0,0-3.585-0.733-7.051-0.901c-2.711-0.131-6.646-0.218-9.061,0 c-1.462,0.132-2.794,0.425-3.808,0.702C358.706,299.745,357.734,300.724,357.399,301.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M357.399,301.949c-1.14,4.169-3.374,15.119-1.545,32.308h19.532 c0.451-3.272-0.121-19.233,4.468-34.65c0,0-3.585-0.733-7.051-0.901c-2.711-0.131-6.646-0.218-9.061,0 c-1.462,0.132-2.794,0.425-3.808,0.702C358.706,299.745,357.734,300.724,357.399,301.949z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M374.937,306.693c-0.591,2.537-1.11,8.563,1.342,12.343c0.509-5.399,1.416-11.658,3.136-17.895 l0.003-0.03C378.027,300.968,375.498,304.314,374.937,306.693z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.95
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M365.691,306.557l-1.073,0.473l-0.818-0.744c-2.75-2.504-2.709-5.43-2.094-7.288 c0.633-0.121,1.318-0.225,2.036-0.29c2.415-0.219,6.349-0.132,9.061,0c0.698,0.034,1.399,0.091,2.075,0.16l-0.682,0.878 C374.048,299.935,370.513,304.437,365.691,306.557z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M372.406,290.233c-0.843,2.915-1.462,6.529,0.396,8.474c0,0-3.32,4.272-7.741,6.216 c-3.285-2.992-1.32-6.216-1.32-6.216c3.323-0.776,3.527-4.797,3.172-7.062L372.406,290.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M366.911,291.647c0.214,1.327,0.23,3.258-0.467,4.786c0.485-0.071,0.988-0.217,1.494-0.446 c1.913-0.865,2.943-2.225,4.071-4.242c0.119-0.517,0.253-1.023,0.396-1.512L366.911,291.647z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M362.182,288.948c0.307,0.993,1.056,1.709,1.835,2.04c1.171,0.498,2.023-0.563,1.922-1.799 c-0.091-1.112-0.811-2.712-2.093-2.684C362.582,286.532,361.832,287.812,362.182,288.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M362.182,288.948c0.307,0.993,1.056,1.709,1.835,2.04c1.171,0.498,2.023-0.563,1.922-1.799 c-0.091-1.112-0.811-2.712-2.093-2.684C362.582,286.532,361.832,287.812,362.182,288.948z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M366.814,282.107c-0.383-2.609-3.288,0.383-3.612,2.292c-0.324,1.908,1.271,3.844,2.354,1.95 C366.638,284.454,367.021,283.517,366.814,282.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M374.713,286.638c-1.253,3.867-1.795,6.177-4.244,7.846c-3.683,2.51-7.923-0.104-7.816-4.165 c0.096-3.655,2.129-9.366,6.266-10.267C372.996,279.163,375.966,282.77,374.713,286.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M372.817,290.688c-1.497-1.025-1.765-1.382-0.966-2.281c1.297-1.458-0.634-1.665,0.388-3.478 c1.419-2.518-3.107-0.748-3.189-2.58c-0.067-1.486-4.027,1.19-4.414-0.523c-0.584-2.58,3.19-2.11,3.858-3.366 c0.668-1.256,4.536-1.446,5.159,0.386c0.622,1.832,2.567,0.374,3.835,2.618c1.267,2.244-1.359,2.404-0.09,4.587 c1.015,1.745-0.931,2.956-2.295,4.388C374.246,291.338,373.746,291.323,372.817,290.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M375.563,290.722c-0.706,0.864-1.714,1.353-2.588,1.47c-1.314,0.177-1.674-1.043-1.059-2.188 c0.553-1.031,1.903-2.365,3.102-2.015C376.199,288.333,376.371,289.734,375.563,290.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M368.645,286.717c-0.083,0.318-0.315,0.547-0.518,0.512c-0.203-0.036-0.3-0.322-0.217-0.641 c0.083-0.318,0.315-0.547,0.518-0.512C368.63,286.112,368.728,286.399,368.645,286.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M365.135,286.102c-0.083,0.318-0.315,0.547-0.518,0.512c-0.203-0.035-0.3-0.322-0.217-0.641 c0.083-0.318,0.315-0.547,0.518-0.512C365.121,285.497,365.218,285.784,365.135,286.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED893E"
    },
    d: "M366.21,286.456c0,0-1.185,1.712-2.193,2.462c0.412,0.622,1.409,0.545,1.409,0.545 L366.21,286.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M366.102,290.5c-0.05-0.009-0.08-0.058-0.067-0.109c0.013-0.052,0.065-0.086,0.116-0.078 c1.363,0.239,2.253-0.625,2.262-0.634c0.039-0.038,0.099-0.041,0.133-0.005c0.035,0.035,0.032,0.095-0.007,0.134 C368.5,289.847,367.563,290.756,366.102,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M370.004,285.742c-0.055-0.01-0.103-0.045-0.126-0.099c-0.318-0.751-0.998-0.828-1.006-0.828 c-0.097-0.006-0.169-0.103-0.15-0.208c0.02-0.104,0.119-0.18,0.221-0.17c0.036,0.003,0.889,0.099,1.283,1.031 c0.039,0.093-0.007,0.208-0.104,0.256C370.085,285.743,370.043,285.749,370.004,285.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M363.892,284.551c-0.026-0.006-0.051-0.019-0.072-0.038c-0.074-0.066-0.075-0.185-0.002-0.267 c0.732-0.812,1.587-0.729,1.623-0.725c0.1,0.007,0.168,0.104,0.148,0.209c-0.021,0.104-0.119,0.179-0.221,0.168l0,0 c-0.028-0.003-0.697-0.061-1.281,0.587C364.034,284.545,363.958,284.568,363.892,284.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M381.984,305.411l-5.567,2.123c0,0,3.396,13.269,2.294,15.049 c-1.499,2.422-4.167,7.851-6.436,10.411c0.016,0.658,0.589,2.277,1.061,2.637c4.499-2.018,10.741-9.998,11.289-12.473 C385.875,317.513,381.984,305.411,381.984,305.411z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M380.981,299.832c3.547,1.131,4.517,14.662,4.517,14.662l-9.3,1.439 c0,0-1.409-4.943-1.942-9.752C373.698,301.142,377.177,298.618,380.981,299.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M380.981,299.832c3.547,1.131,4.517,14.662,4.517,14.662l-9.3,1.439 c0,0-1.409-4.943-1.942-9.752C373.698,301.142,377.177,298.618,380.981,299.832z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M374.213,332.77l-3.669-0.759l1.06,4.394c0,0,3.24,0.556,4.334-1.886L374.213,332.77z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB573"
    },
    points: "367.099,333.517 368.261,337.432 371.604,336.404 370.544,332.01  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7191 -0.6949 0.6949 0.7191 -78.4493 258.5808)",
    style: {
      fill: "#407BFF"
    },
    cx: 280.622,
    cy: 226.327,
    rx: 32.082,
    ry: 29.96
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_00000071534439631619993440000015325121961686270648_",
    transform: "matrix(0.7191 -0.6949 0.6949 0.7191 -78.4493 258.5811)",
    cx: 280.622,
    cy: 226.327,
    rx: 30.394,
    ry: 28.383
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071534439631619993440000015325121961686270648_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044162330546084484200000012396045966589797541_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071534439631619993440000015325121961686270648_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044162330546084484200000012396045966589797541_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M292.906,233.247c0.157,2.385,0.273,4.779,0.369,7.168l0.288,7.141l0.048,0.869l0.07,0.765 c0.078,0.525,0.139,1.065,0.249,1.616c0.208,1.1,0.485,2.221,0.799,3.341c0.601,2.249,1.33,4.521,2.044,6.767l-2.072,0.964 c-1.269-2.122-2.336-4.302-3.309-6.584c-0.461-1.15-0.892-2.322-1.265-3.549c-0.186-0.612-0.358-1.248-0.489-1.904 l-0.164-1.019l-0.107-0.923c-0.524-4.839-0.873-9.605-1.068-14.417L292.906,233.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M291.807,228.009c1.827,0.474,2.605,8.127,2.605,8.127l-7.444,4.837 c0,0-2.305-9.073-0.734-11.118C287.869,227.727,289.14,227.318,291.807,228.009z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "291.522,229.719 292.423,237.433 289.408,239.387  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M296.789,260.391l2.054,4.248l-3.948,0.106c0,0-1.149-3.021,0.076-4.525L296.789,260.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M271.496,208.285c-3.122,0.449-9.681,15.407,1.01,22.387 c10.691,6.98,18.563-0.947,18.563-0.947s-6.501-7.728-5.558-12.764c0.943-5.036,5.001-11.391-3.323-13.512 C276.318,201.952,268.44,203.398,271.496,208.285z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB573"
    },
    points: "298.973,266.741 295.625,266.461 294.895,264.745 298.843,264.639  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M291.807,228.009c0,0,2.098,0.757-4.021,27.236c-7.272,0-14.789,0-18.328,0 c0.818-7.459,1.142-12.059-1.375-27.367c0,0,3.897-0.835,7.853-1.025c3.094-0.149,5.628-0.247,8.322,0 C287.81,227.18,291.807,228.009,291.807,228.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M269.18,233.939c1.631,0.414,3.041,2.225,2.63,5.56c-0.247,2-1.267,3.513-1.816,4.199 c-0.118-2.565-0.406-5.544-0.925-9.356L269.18,233.939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M282.892,232.723c0,0-3.175,2.472-3.355,5.103c-2.371-1.829-5.394-6.81-5.529-9.99 c-0.023-0.536,0.438-1.009,0.979-1.041c0.282-0.017,0.51-0.052,0.673-0.086c0.194-0.04,0.386,0.01,0.528,0.134 L282.892,232.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M282.892,232.723c0,0,2.648,1.416,2.911,4.904c2.655-1.852,1.745-7.381,0.522-10.085 c-0.193-0.428-0.597-0.716-1.072-0.772c-0.367-0.043-0.646-0.092-0.829-0.13c-0.141-0.029-0.282,0.069-0.312,0.213 L282.892,232.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M277.402,217.482c0.342,2.678,0.53,7.584-1.466,9.371c0,0,2.25,3.296,6.956,5.87 c3.916-2.967,1.366-5.87,1.366-5.87c-2.937-0.713-2.708-2.929-2.046-5.009L277.402,217.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M279.363,219.262l2.847,2.58c-0.159,0.492-0.29,0.992-0.358,1.477 c-1.129-0.165-2.857-1.137-3.017-2.377C278.759,220.355,279.247,219.54,279.363,219.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M273.207,213.182c0.943,4.304,1.249,6.152,3.831,7.902c3.884,2.632,9.068,0.17,9.455-4.417 c0.348-4.129-1.253-10.474-5.856-11.261C276.101,204.63,272.264,208.877,273.207,213.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M274.436,217.06c2.774-2.643,2.873-5.909,2.17-6.931c2.382-0.2,8.542-1.695,7.553-3.989 c-0.99-2.294-10.577-3.54-11.902,2.343C269.083,211.127,271.111,216.462,274.436,217.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M280.45,212.793c0.055,0.355,0.29,0.602,0.526,0.55c0.236-0.052,0.383-0.382,0.328-0.737 c-0.055-0.355-0.29-0.601-0.526-0.55C280.543,212.108,280.396,212.438,280.45,212.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M284.528,211.9c0.055,0.355,0.29,0.602,0.526,0.55c0.236-0.052,0.383-0.382,0.328-0.737 c-0.055-0.355-0.29-0.602-0.526-0.55C284.62,211.215,284.473,211.545,284.528,211.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M284.754,211.206l0.829-0.436C285.583,210.77,285.241,211.534,284.754,211.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5652"
    },
    d: "M283.369,212.816c0,0,0.847,1.396,1.635,1.986c-0.409,0.542-1.249,0.519-1.249,0.519 L283.369,212.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M282.001,217.143c0.17-0.011,0.349-0.036,0.537-0.077c0.059-0.013,0.099-0.07,0.09-0.127 c-0.009-0.058-0.064-0.097-0.122-0.081c-1.584,0.344-2.49-0.581-2.499-0.59c-0.039-0.041-0.107-0.041-0.151,0.002 c-0.044,0.042-0.048,0.11-0.009,0.151C279.883,216.457,280.641,217.233,282.001,217.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M272.628,217.475c0.461,0.773,1.253,1.236,1.994,1.374c1.115,0.208,1.646-0.827,1.316-1.838 c-0.298-0.91-1.237-2.115-2.345-1.865C272.5,215.393,272.1,216.591,272.628,217.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M278.535,212.014c0.09-0.012,0.17-0.08,0.193-0.174c0.242-0.973,1.431-1.519,1.442-1.524 c0.11-0.05,0.165-0.177,0.123-0.284c-0.042-0.107-0.165-0.154-0.277-0.104c-0.057,0.026-1.408,0.647-1.704,1.836 c-0.029,0.116,0.041,0.227,0.155,0.248C278.491,212.017,278.513,212.017,278.535,212.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M285.516,209.056c0.073,0.003,0.148-0.03,0.195-0.096c0.072-0.099,0.053-0.231-0.041-0.296 c-0.943-0.65-1.879-0.267-1.918-0.25c-0.112,0.047-0.17,0.173-0.13,0.281c0.04,0.108,0.161,0.157,0.273,0.111 c0.037-0.016,0.766-0.302,1.515,0.215C285.443,209.042,285.479,209.054,285.516,209.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M280.677,212.099l0.828-0.436C281.506,211.663,281.164,212.427,280.677,212.099z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M269.258,254.17l-0.581,1.641c-0.073,0.127,0.069,0.257,0.281,0.257h18.863 c0.165,0,0.308-0.081,0.325-0.185l0.278-1.641c0.019-0.114-0.117-0.21-0.298-0.21h-18.559 C269.429,254.032,269.304,254.088,269.258,254.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M269.258,254.17l-0.581,1.641c-0.073,0.127,0.069,0.257,0.281,0.257h18.863 c0.165,0,0.308-0.081,0.325-0.185l0.278-1.641c0.019-0.114-0.117-0.21-0.298-0.21h-18.559 C269.429,254.032,269.304,254.088,269.258,254.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M271.669,256.245h-0.497c-0.099,0-0.171-0.051-0.16-0.113l0.379-2.131 c0.011-0.062,0.101-0.113,0.2-0.113h0.497c0.099,0,0.171,0.051,0.16,0.113l-0.379,2.131 C271.858,256.194,271.768,256.245,271.669,256.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M271.669,256.245h-0.497c-0.099,0-0.171-0.051-0.16-0.113l0.379-2.131 c0.011-0.062,0.101-0.113,0.2-0.113h0.497c0.099,0,0.171,0.051,0.16,0.113l-0.379,2.131 C271.858,256.194,271.768,256.245,271.669,256.245z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M286.411,256.245h-0.497c-0.099,0-0.171-0.051-0.16-0.113l0.379-2.131 c0.011-0.062,0.101-0.113,0.2-0.113h0.497c0.099,0,0.171,0.051,0.16,0.113l-0.379,2.131 C286.6,256.194,286.51,256.245,286.411,256.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M286.411,256.245h-0.497c-0.099,0-0.171-0.051-0.16-0.113l0.379-2.131 c0.011-0.062,0.101-0.113,0.2-0.113h0.497c0.099,0,0.171,0.051,0.16,0.113l-0.379,2.131 C286.6,256.194,286.51,256.245,286.411,256.245z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M279.071,256.245h-0.497c-0.099,0-0.171-0.051-0.16-0.113l0.379-2.131 c0.011-0.062,0.101-0.113,0.2-0.113h0.497c0.099,0,0.171,0.051,0.16,0.113l-0.379,2.131 C279.26,256.194,279.17,256.245,279.071,256.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M279.071,256.245h-0.497c-0.099,0-0.171-0.051-0.16-0.113l0.379-2.131 c0.011-0.062,0.101-0.113,0.2-0.113h0.497c0.099,0,0.171,0.051,0.16,0.113l-0.379,2.131 C279.26,256.194,279.17,256.245,279.071,256.245z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M280.22,258.903l4.587-1.989l-1.57,4.41c0,0-2.87,0.641-4.003-0.775L280.22,258.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M270.118,233.988c-0.514,3.054-1.104,6.094-1.707,9.132c-0.288,1.521-0.622,3.034-0.937,4.551 l-0.479,2.273l-0.207,0.983c-0.017,0.055-0.022,0.107,0.01,0.227c0.06,0.232,0.333,0.681,0.758,1.092 c0.418,0.421,0.955,0.832,1.527,1.217c1.156,0.776,2.483,1.43,3.826,2.068c1.35,0.633,2.751,1.205,4.172,1.735 c1.41,0.553,2.871,1.049,4.294,1.525l-0.516,2.227c-3.146-0.517-6.185-1.279-9.229-2.336c-1.521-0.53-3.018-1.172-4.51-2.003 c-0.744-0.426-1.487-0.898-2.215-1.521c-0.71-0.627-1.481-1.387-1.958-2.617c-0.233-0.606-0.358-1.34-0.283-2.055 c0.049-0.428,0.072-0.514,0.103-0.73l0.089-0.574l0.356-2.295c0.241-1.529,0.463-3.062,0.732-4.585 c0.51-3.053,1.033-6.103,1.632-9.14L270.118,233.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M268.083,227.879c-1.874,0.558-4.513,6.881-4.513,6.881l5.972,6.615 c0,0,3.762-6.8,3.153-9.173C272.061,229.73,270.222,227.242,268.083,227.879z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB573"
    },
    points: "288.427,257.829 286.916,261.464 283.237,261.324 284.807,256.914  "
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    d: "M257.32,149.846h71.656c1.361,0,2.54-1.104,2.634-2.465l0,0 c0.093-1.361-0.935-2.465-2.296-2.465h-71.656c-1.361,0-2.54,1.104-2.633,2.465l0,0 C254.93,148.742,255.958,149.846,257.32,149.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    d: "M277.12,160.687h51.113c1.361,0,2.54-1.104,2.633-2.465l0,0 c0.093-1.361-0.935-2.465-2.296-2.465h-51.113c-1.361,0-2.54,1.104-2.633,2.465l0,0 C274.731,159.584,275.759,160.687,277.12,160.687z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M289.065,139.004h40.653c1.361,0,2.54-1.104,2.633-2.465l0,0c0.093-1.361-0.935-2.465-2.296-2.465 h-40.653c-1.361,0-2.54,1.104-2.634,2.465l0,0C286.676,137.901,287.704,139.004,289.065,139.004z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    d: "M289.146,308.228h28.986c1.361,0,2.389,1.104,2.296,2.465l0,0 c-0.093,1.361-1.272,2.465-2.634,2.465h-28.986c-1.361,0-2.389-1.104-2.296-2.465l0,0 C286.606,309.332,287.785,308.228,289.146,308.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    d: "M249.884,308.228h28.986c1.361,0,2.389,1.104,2.296,2.465l0,0 c-0.093,1.361-1.272,2.465-2.634,2.465h-28.986c-1.361,0-2.389-1.104-2.296-2.465l0,0 C247.344,309.332,248.523,308.228,249.884,308.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    d: "M267.761,297.387h51.113c1.361,0,2.389,1.104,2.296,2.465l0,0 c-0.093,1.361-1.272,2.465-2.634,2.465h-51.113c-1.361,0-2.389-1.104-2.296-2.465l0,0 C265.221,298.49,266.4,297.387,267.761,297.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.025,286.545h58.592c1.361,0,2.389,1.104,2.296,2.465l0,0 c-0.093,1.361-1.272,2.465-2.634,2.465h-58.592c-1.361,0-2.389-1.104-2.296-2.465l0,0 C258.484,287.648,259.663,286.545,261.025,286.545z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    d: "M382.797,234.704h-53.395c-1.361,0-2.54,1.104-2.634,2.465l0,0 c-0.093,1.361,0.935,2.465,2.296,2.465h53.395c1.361,0,2.54-1.104,2.634-2.465l0,0 C385.186,235.807,384.158,234.704,382.797,234.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    d: "M355.341,223.862h-25.197c-1.361,0-2.54,1.104-2.634,2.465l0,0 c-0.093,1.361,0.935,2.465,2.296,2.465h25.197c1.361,0,2.54-1.104,2.634-2.465l0,0 C357.73,224.965,356.702,223.862,355.341,223.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M370.095,213.02h-39.208c-1.361,0-2.54,1.104-2.634,2.465l0,0 c-0.093,1.361,0.935,2.465,2.296,2.465h39.208c1.361,0,2.54-1.104,2.634-2.465l0,0C372.484,214.124,371.456,213.02,370.095,213.02 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    d: "M401.8,223.862h-35.802c-1.361,0-2.54,1.104-2.633,2.465l0,0 c-0.093,1.361,0.935,2.465,2.296,2.465h35.802c1.361,0,2.54-1.104,2.634-2.465l0,0C404.189,224.965,403.161,223.862,401.8,223.862 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#407BFF"
    },
    points: "240.809,121.599 267.591,121.599 266.173,97.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "240.809,121.599 269.48,118.167 266.173,97.869  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M132.784,191.905c-0.853,2.007-1.793,4.217-2.626,6.357c-0.838,2.164-1.682,4.324-2.443,6.502 c-1.562,4.34-2.921,8.724-3.852,13.034c-0.138,0.543-0.207,1.069-0.311,1.604l-0.146,0.801l-0.106,0.627 c-0.103,0.699-0.11,1.67-0.059,2.678c0.127,2.038,0.477,4.273,0.892,6.514c0.862,4.487,1.998,9.141,3.131,13.701l-5.081,2.147 c-2.521-4.343-4.629-8.769-6.362-13.553c-0.855-2.399-1.613-4.86-2.113-7.596c-0.25-1.378-0.437-2.818-0.391-4.522l0.028-0.65 c0.012-0.214,0.031-0.342,0.046-0.518l0.098-0.988c0.072-0.655,0.117-1.328,0.222-1.965c0.717-5.177,1.976-10.086,3.494-14.861 c0.774-2.383,1.58-4.746,2.508-7.059c0.933-2.337,1.83-4.577,2.975-6.949L132.784,191.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M127.087,242.436l3.902,3.807l-8.508,3.958c0,0-2.065-3.605-0.639-6.865L127.087,242.436z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "134.132,251.912 126.946,254.855 122.48,250.202 130.989,246.243  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 -26.631 379.5151)",
    style: {
      fill: "#407BFF"
    },
    cx: 270.677,
    cy: 209.686,
    rx: 53.162,
    ry: 53.162
  }), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000155835446906068286640000014927018896758256559_",
    cx: 270.677,
    cy: 209.686,
    r: 50.364
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155835446906068286640000014927018896758256559_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150792692230641291850000008055782744776943796_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155835446906068286640000014927018896758256559_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000150792692230641291850000008055782744776943796_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M292.544,221.285c0.553,4.118,1.036,8.256,1.484,12.389l1.357,12.346l0.184,1.483l0.212,1.326 l0.289,1.381l0.353,1.41c0.515,1.887,1.106,3.812,1.762,5.73c1.284,3.848,2.79,7.716,4.255,11.547l-3.458,1.845 c-2.395-3.559-4.456-7.235-6.382-11.082c-0.927-1.938-1.819-3.913-2.585-5.992l-0.56-1.581l-0.5-1.644 c-0.148-0.567-0.279-1.157-0.416-1.737l-0.312-1.604c-0.764-4.178-1.395-8.297-1.971-12.443 c-0.596-4.139-1.131-8.276-1.569-12.436L292.544,221.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M290.054,212.571c3.189,0.812,5.42,13.936,5.42,13.936l-12.197,8.295 c0,0-5.018-15.558-2.564-19.064C283.267,212.086,285.4,211.386,290.054,212.571z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "289.766,215.502 292.216,228.73 287.276,232.08  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M302.397,268.096l4.021,7.285l-6.756,0.182c0,0-2.325-5.181-0.401-7.759L302.397,268.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M252.911,178.748c-5.301,0.77-14.791,26.419,4.36,38.388 c19.151,11.97,31.719-1.625,31.719-1.625s-12.055-13.252-11.029-21.887c1.026-8.635,7.238-19.533-7.285-23.17 C260.435,167.89,247.097,170.37,252.911,178.748z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB573"
    },
    points: "306.888,278.985 301.115,278.506 299.662,275.563 306.418,275.381  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M290.054,212.571c0,0,3.686,1.298-3.698,46.702c-12.47,0-25.359,0-31.427,0 c0.527-12.79,0.542-20.677-5.571-46.926c0,0,6.585-1.432,13.345-1.758c5.288-0.255,9.621-0.424,14.27,0.001 C283.103,211.148,290.054,212.571,290.054,212.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M251.95,222.738c2.846,0.709,5.477,3.816,5.162,9.534c-0.189,3.429-1.76,6.024-2.621,7.2 c-0.503-4.399-1.347-9.507-2.685-16.043L251.95,222.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M275.32,220.654c0,0-5.154,4.24-5.154,8.751c-4.28-3.136-10.048-11.677-10.653-17.131 c-0.102-0.92,0.633-1.729,1.557-1.784c0.481-0.029,0.868-0.09,1.145-0.147c0.328-0.068,0.663,0.017,0.921,0.23 L275.32,220.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M275.32,220.654c0,0,4.707,2.427,5.567,8.41c4.335-3.176,2.125-12.656-0.289-17.293 c-0.382-0.734-1.108-1.229-1.929-1.324c-0.634-0.074-1.118-0.158-1.436-0.222c-0.245-0.049-0.475,0.118-0.509,0.365 L275.32,220.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M264.117,194.52c0.9,4.592,1.798,13.005-1.414,16.068c0,0,4.244,5.651,12.616,10.065 c6.366-5.087,1.654-10.065,1.654-10.065c-5.12-1.223-4.988-5.021-4.096-8.589L264.117,194.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M267.689,197.572l5.185,4.424c-0.214,0.844-0.38,1.701-0.44,2.533 c-1.956-0.283-5.032-1.949-5.452-4.076C266.782,199.446,267.522,198.048,267.689,197.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M256.419,187.145c2.123,7.38,2.864,10.55,7.497,13.55c6.969,4.513,15.57,0.292,15.695-7.574 c0.113-7.08-3.378-17.96-11.364-19.31C260.378,172.482,254.296,179.765,256.419,187.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M258.981,193.796c4.446-4.531,4.232-10.131,2.907-11.884 c4.061-0.342,14.449-2.907,12.483-6.84c-1.966-3.933-18.553-6.07-20.135,4.018 C249.106,183.622,253.21,192.77,258.981,193.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M268.794,186.479c0.135,0.609,0.568,1.031,0.966,0.943c0.398-0.089,0.611-0.654,0.476-1.263 c-0.135-0.609-0.568-1.031-0.966-0.943C268.872,185.304,268.659,185.87,268.794,186.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M275.681,184.949c0.135,0.609,0.568,1.031,0.966,0.943c0.398-0.089,0.611-0.654,0.476-1.263 c-0.135-0.609-0.568-1.031-0.966-0.943C275.758,183.774,275.545,184.339,275.681,184.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M275.988,183.758l1.37-0.747C277.358,183.011,276.861,184.321,275.988,183.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5652"
    },
    d: "M273.801,186.518c0,0,1.617,2.393,3.036,3.406c-0.637,0.93-2.081,0.89-2.081,0.89 L273.801,186.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M271.964,193.939c0.29-0.019,0.594-0.061,0.913-0.132c0.099-0.022,0.161-0.12,0.14-0.218 c-0.022-0.099-0.121-0.166-0.219-0.139c-2.676,0.59-4.338-0.996-4.354-1.012c-0.073-0.071-0.188-0.07-0.259,0.003 c-0.071,0.072-0.069,0.189,0.003,0.259C268.252,192.762,269.642,194.092,271.964,193.939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M255.93,194.508c0.882,1.325,2.294,2.12,3.581,2.357c1.935,0.356,2.726-1.418,2.04-3.152 c-0.618-1.561-2.369-3.627-4.24-3.198C255.467,190.937,254.921,192.992,255.93,194.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M265.418,185.143c0.153-0.021,0.282-0.137,0.311-0.298c0.301-1.669,2.275-2.605,2.294-2.614 c0.184-0.085,0.263-0.303,0.178-0.487c-0.085-0.183-0.301-0.264-0.487-0.178c-0.096,0.044-2.338,1.109-2.706,3.148 c-0.036,0.199,0.096,0.39,0.296,0.426C265.343,185.148,265.382,185.148,265.418,185.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M277.042,180.07c0.125,0.006,0.25-0.052,0.324-0.164c0.111-0.169,0.064-0.396-0.105-0.508 c-1.693-1.115-3.253-0.458-3.318-0.429c-0.186,0.081-0.271,0.297-0.19,0.482c0.081,0.185,0.295,0.269,0.482,0.19 c0.062-0.027,1.279-0.517,2.623,0.369C276.914,180.048,276.978,180.068,277.042,180.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M269.102,185.289l1.37-0.747C270.471,184.542,269.974,185.852,269.102,185.289z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M254.458,257.429l-0.804,2.813c-0.11,0.218,0.148,0.441,0.512,0.441h32.344 c0.283,0,0.518-0.139,0.536-0.317l0.284-2.813c0.02-0.195-0.226-0.36-0.536-0.36H254.97 C254.736,257.193,254.529,257.288,254.458,257.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M254.458,257.429l-0.804,2.813c-0.11,0.218,0.148,0.441,0.512,0.441h32.344 c0.283,0,0.518-0.139,0.536-0.317l0.284-2.813c0.02-0.195-0.226-0.36-0.536-0.36H254.97 C254.736,257.193,254.529,257.288,254.458,257.429z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M258.838,260.987h-0.852c-0.17,0-0.299-0.087-0.287-0.194l0.4-3.655 c0.012-0.107,0.16-0.195,0.33-0.195h0.852c0.17,0,0.299,0.087,0.287,0.195l-0.4,3.655 C259.156,260.9,259.007,260.987,258.838,260.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M258.838,260.987h-0.852c-0.17,0-0.299-0.087-0.287-0.194l0.4-3.655 c0.012-0.107,0.16-0.195,0.33-0.195h0.852c0.17,0,0.299,0.087,0.287,0.195l-0.4,3.655 C259.156,260.9,259.007,260.987,258.838,260.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M284.116,260.987h-0.852c-0.17,0-0.299-0.087-0.287-0.194l0.4-3.655 c0.012-0.107,0.16-0.195,0.33-0.195h0.852c0.17,0,0.299,0.087,0.287,0.195l-0.4,3.655 C284.434,260.9,284.285,260.987,284.116,260.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M284.116,260.987h-0.852c-0.17,0-0.299-0.087-0.287-0.194l0.4-3.655 c0.012-0.107,0.16-0.195,0.33-0.195h0.852c0.17,0,0.299,0.087,0.287,0.195l-0.4,3.655 C284.434,260.9,284.285,260.987,284.116,260.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M271.529,260.987h-0.852c-0.17,0-0.299-0.087-0.287-0.194l0.4-3.655 c0.012-0.107,0.16-0.195,0.33-0.195h0.852c0.17,0,0.299,0.087,0.287,0.195l-0.4,3.655 C271.847,260.9,271.699,260.987,271.529,260.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M271.529,260.987h-0.852c-0.17,0-0.299-0.087-0.287-0.194l0.4-3.655 c0.012-0.107,0.16-0.195,0.33-0.195h0.852c0.17,0,0.299,0.087,0.287,0.195l-0.4,3.655 C271.847,260.9,271.699,260.987,271.529,260.987z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M273.813,265.545l7.632-3.411l-2.175,7.562c0,0-4.846,1.099-6.954-1.33L273.813,265.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M253.555,222.56c-0.254,2.665-0.588,5.32-0.879,7.981l-1.011,7.966 c-0.319,2.657-0.731,5.304-1.096,7.956l-0.564,3.976l-0.183,1.266c-0.003,0.102,0.026,0.284,0.155,0.554 c0.246,0.546,0.888,1.325,1.696,2.027c0.814,0.714,1.783,1.399,2.814,2.041c2.059,1.309,4.37,2.423,6.715,3.501 c2.355,1.068,4.789,2.034,7.257,2.933c2.448,0.938,4.979,1.78,7.447,2.589l-0.871,3.821 c-5.432-0.882-10.689-2.169-15.952-3.938c-2.633-0.878-5.229-1.937-7.82-3.281c-1.29-0.685-2.574-1.462-3.842-2.429 c-1.253-0.988-2.554-2.127-3.597-3.937c-0.507-0.903-0.929-2.009-1.058-3.242c-0.02-0.309-0.047-0.619-0.036-0.93 c0.008-0.283,0.038-0.701,0.049-0.801l0.086-1l0.348-3.999c0.242-2.664,0.438-5.334,0.726-7.994l0.812-7.984 c0.316-2.656,0.589-5.317,0.943-7.969L253.555,222.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M249.358,212.347c-3.148,0.958-6.93,11.799-6.93,11.799l11.017,11.344 c0,0,5.653-11.66,4.33-15.73C256.397,215.521,252.951,211.254,249.358,212.347z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB573"
    },
    points: "287.758,263.704 285.595,269.937 279.27,269.697 281.445,262.134  "
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#407BFF"
    },
    d: "M222.522,222.661c-7.167-26.59,8.577-53.962,35.173-61.131 c26.597-7.169,53.964,8.583,61.131,35.173c7.169,26.597-8.575,53.968-35.172,61.137 C257.058,265.009,229.691,249.258,222.522,222.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M306.823,175.32l-41.07,84c3.47,0.35,7.021,0.34,10.59-0.09l36.93-75.5 C311.413,180.68,309.253,177.86,306.823,175.32z M318.823,196.7c-0.09-0.32-0.18-0.65-0.27-0.97l-29.49,60.32 C312.343,246.85,325.493,221.44,318.823,196.7z M257.693,161.53c-26.59,7.17-42.34,34.54-35.17,61.13 c2.65,9.84,8.07,18.19,15.19,24.45l42.27-86.43C272.803,159.31,265.223,159.5,257.693,161.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M214.564,204.27l-0.996-0.096c0.165-1.712,0.409-3.433,0.729-5.113l0.982,0.187 C214.966,200.899,214.726,202.588,214.564,204.27z M216.504,194.117l-0.961-0.278c1.28-4.422,3.107-8.712,5.432-12.753 l0.867,0.499C219.557,185.556,217.761,189.772,216.504,194.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M322.659,195.671c-7.738-28.71-37.287-45.712-65.997-37.973 c-28.71,7.738-45.712,37.287-37.973,65.997c7.74,28.714,37.289,45.716,65.998,37.978 C313.397,253.935,330.399,224.386,322.659,195.671z M222.522,222.661c-7.167-26.59,8.577-53.962,35.173-61.131 c26.597-7.169,53.964,8.583,61.131,35.173c7.169,26.597-8.575,53.968-35.172,61.137 C257.058,265.009,229.691,249.258,222.522,222.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M223.324,230.906c-0.029,2.297-0.597,2.592-1.225,2.668l-1.814,0.479l-3.629,0.958l-7.258,1.917 l-14.545,3.733c-9.709,2.439-19.438,4.808-29.18,7.126l-29.222,6.969l-14.594,3.547c-4.858,1.207-9.741,2.322-14.546,3.728 c-2.053,0.601-4.204-0.576-4.806-2.629c-0.601-2.053,0.576-4.205,2.629-4.806c0.049-0.014,0.112-0.031,0.161-0.043 c4.86-1.199,9.642-2.689,14.449-4.087l14.4-4.268l28.767-8.661c9.587-2.892,19.188-5.733,28.809-8.504l14.45-4.082l7.239-1.99 l3.619-0.995l1.809-0.498c0.581-0.25,1.221-0.28,2.4,1.691C222.679,225.57,223.349,228.288,223.324,230.906z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160.398,156.296c-0.001,0.593,0.313,1.073,0.7,1.074c0.387,0,0.702-0.48,0.702-1.072 c0.001-0.592-0.313-1.073-0.701-1.073C160.712,155.223,160.398,155.703,160.398,156.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#630F0F"
    },
    d: "M160.656,157.369c0,0,1.344,3.42,2.826,5.07c-1.049,0.978-2.831,0.529-2.831,0.529L160.656,157.369 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.301,153.01c-0.108,0-0.215-0.05-0.283-0.145c-0.112-0.156-0.077-0.373,0.079-0.486 c1.563-1.125,3.067-0.561,3.131-0.536c0.179,0.07,0.268,0.271,0.198,0.45c-0.069,0.179-0.273,0.266-0.448,0.199l0,0 c-0.049-0.019-1.227-0.446-2.475,0.451C158.442,152.989,158.371,153.01,158.301,153.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M141.324,160.128c0.521,5.79,0.601,16.317-3.495,19.768c0,0,0.927,5.91,10.871,6.832 c10.934,1.014,5.761-5.289,5.761-5.289c-5.827-2.069-5.236-6.765-3.786-11.091L141.324,160.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M125.332,397.31c-0.859,0.357-2.831-0.509-3.459-0.876c-0.059-0.035-0.093-0.101-0.085-0.169 c0.008-0.068,0.056-0.128,0.119-0.147c0.099-0.032,2.444-0.778,3.397-0.227c0.219,0.127,0.356,0.311,0.406,0.546 c0.095,0.447-0.074,0.678-0.232,0.792C125.435,397.261,125.385,397.288,125.332,397.31z M122.419,396.332 c0.997,0.493,2.429,0.917,2.855,0.615c0.041-0.029,0.164-0.118,0.096-0.438c-0.029-0.136-0.108-0.24-0.24-0.317 C124.564,395.865,123.22,396.12,122.419,396.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M122.512,396.286c-0.192,0.08-0.369,0.138-0.515,0.169c-0.062,0.013-0.127-0.009-0.169-0.058 c-0.041-0.049-0.052-0.116-0.029-0.175c0.033-0.084,0.811-2.061,1.829-2.484c0.001,0,0.001,0,0.002-0.001 c0.265-0.11,0.525-0.11,0.774-0.001c0.384,0.169,0.414,0.446,0.399,0.596C124.73,395.018,123.436,395.902,122.512,396.286z  M122.269,396.012c0.9-0.337,2.136-1.226,2.188-1.716c0.005-0.045,0.016-0.15-0.193-0.242c-0.161-0.071-0.324-0.07-0.5,0.003 c-0.001,0-0.001,0-0.001,0.001C123.109,394.329,122.529,395.444,122.269,396.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M170.764,409.114c-0.879,0-1.785-0.113-2.254-0.206c-0.071-0.014-0.126-0.071-0.138-0.143 c-0.012-0.072,0.022-0.143,0.085-0.179c0.109-0.063,2.673-1.526,3.899-1.193c0.25,0.068,0.437,0.205,0.551,0.407 c0.206,0.36,0.122,0.612,0.015,0.76C172.617,408.984,171.706,409.114,170.764,409.114z M169.072,408.65 c1.367,0.193,3.226,0.182,3.568-0.292c0.045-0.062,0.089-0.169-0.034-0.385c-0.069-0.12-0.18-0.2-0.341-0.243 C171.514,407.525,169.969,408.189,169.072,408.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M168.544,408.911c-0.036,0-0.071-0.011-0.102-0.033c-0.05-0.036-0.078-0.096-0.072-0.158 c0.008-0.084,0.206-2.063,1.141-2.83c0.286-0.234,0.612-0.335,0.965-0.299c0.478,0.049,0.616,0.291,0.648,0.486 c0.134,0.831-1.623,2.419-2.509,2.817C168.593,408.906,168.569,408.911,168.544,408.911z M170.337,405.933 c-0.221,0-0.419,0.074-0.605,0.227c-0.614,0.503-0.876,1.687-0.97,2.265c0.905-0.544,2.099-1.793,2.018-2.291 c-0.006-0.041-0.026-0.164-0.339-0.196C170.406,405.935,170.371,405.933,170.337,405.933z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "160.467,408.737 167.813,408.737 168.544,391.724 161.198,391.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "113.674,394.698 120.893,396.057 129.017,380.276 121.798,378.916  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M121.682,395.312l-7.903-2.38c-0.288-0.087-0.597,0.038-0.744,0.3l-3.272,5.834 c-0.339,0.605-0.015,1.372,0.653,1.561c2.773,0.783,4.162,1.025,7.638,2.072c2.138,0.644,7.76,2.98,10.713,3.869 c2.888,0.87,4.217-1.914,3.088-2.543c-5.063-2.818-7.896-5.855-9.162-7.937C122.465,395.712,122.102,395.438,121.682,395.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M167.764,407.886h-8.023c-0.3,0-0.56,0.209-0.626,0.502l-1.451,6.53 c-0.15,0.677,0.363,1.319,1.057,1.307c2.894-0.049,7.076-0.219,10.713-0.219c4.253,0,7.926,0.232,12.914,0.232 c3.016,0,3.853-3.049,2.591-3.325c-5.747-1.257-10.44-1.392-15.406-4.454C168.994,408.126,168.398,407.886,167.764,407.886z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M124.036,181.767c-6.372,3.05-9.04,23.566-9.04,23.566l14.651,5.746c0,0,3.504-8.299,5.507-17.154 C137.252,184.648,130.551,178.649,124.036,181.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M124.036,181.767c-6.372,3.05-9.04,23.566-9.04,23.566l14.651,5.746c0,0,3.504-8.299,5.507-17.154 C137.252,184.648,130.551,178.649,124.036,181.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M133.532,187.8c0.52-0.25,1.04-0.44,1.56-0.57c0.55,1.92,0.63,4.19,0.06,6.7 c-2,8.85-5.5,17.15-5.5,17.15l-4.83-1.89C125.712,203.82,128.442,190.24,133.532,187.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M166.52,181.611c0,0,7.819,8.832,0.435,63.497c-11.839,0-33.532,0-39.293,0 c-0.271-6.032,3.519-35.456-2.298-63.876c0,0,6.735-1.352,13.153-1.661c5.021-0.242,12.29-0.402,16.703,0.001 C161.039,180.103,166.52,181.611,166.52,181.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M166.52,181.611c0,0,7.819,8.832,0.435,63.497c-11.839,0-33.532,0-39.293,0 c-0.271-6.032,3.519-35.456-2.298-63.876c0,0,6.735-1.352,13.153-1.661c5.021-0.242,12.29-0.402,16.703,0.001 C161.039,180.103,166.52,181.611,166.52,181.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M158.612,193.33c1.78-5.34,6.06-7.05,10.42-3.88c0.88,5.18,1.5,13.53,0.79,26.77l-7.67-0.07 C162.152,216.15,155.962,201.28,158.612,193.33z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M171.064,189.684c0.374,2.282,0.792,4.782,1.27,7.163c0.491,2.402,0.977,4.804,1.554,7.168 c1.124,4.726,2.448,9.397,4.216,13.606c0.442,1.044,0.909,2.059,1.412,3.01l0.657,1.175c0.093,0.194,0.315,0.462,0.566,0.742 c1.089,1.195,3.028,2.432,5.018,3.54c4.068,2.193,8.751,4.106,13.315,5.858l-1.097,5.406c-5.365-0.43-10.503-1.365-15.775-3.221 c-1.315-0.476-2.641-1.01-3.968-1.695c-1.33-0.684-2.682-1.473-4.051-2.584c-0.68-0.584-1.363-1.219-2.02-2.054l-0.484-0.635 l-0.311-0.465c-0.203-0.31-0.419-0.621-0.609-0.932c-0.78-1.246-1.466-2.5-2.106-3.758c-2.476-5.046-4.158-10.143-5.543-15.269 c-0.672-2.567-1.287-5.134-1.783-7.722c-0.505-2.609-0.966-5.122-1.299-7.878L171.064,189.684z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M156.702,186.968c-2.07,6.712,6.324,26.717,6.324,26.717l17.696-4.45 c0,0-1.624-10.146-5.432-18.396C169.547,178.393,159.186,178.913,156.702,186.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M156.702,186.968c-2.07,6.712,6.324,26.717,6.324,26.717l17.696-4.45 c0,0-1.624-10.146-5.432-18.396C169.547,178.393,159.186,178.913,156.702,186.968z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M199.177,231.956l7.588,3.415l-7.351,6.069c0,0-3.246-1.059-3.775-6.383l-1.133-4.418l3.334,0.85 C198.299,231.605,198.746,231.762,199.177,231.956z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7F3E3B"
    },
    points: "210.803,239.095 203.406,243.499 199.414,241.439 206.765,235.371  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.558,178.922c-3.17-2.68-10.867-4.607-19.492-5.089c-4.923-0.274-9.989,0.534-12.105,1.476 c-2.117,0.941,0.384,7.735,3.146,7.881c-1.456,2.297,0.663,6.737,3.831,7.607c-0.502,3.841,9.18,4.199,15.039,1.103 C153.643,189.434,162.357,182.134,158.558,178.922z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "168.543,391.729 168.167,400.498 160.818,400.498 161.193,391.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "121.794,378.92 129.016,380.28 124.825,388.414 117.603,387.054  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M140.635,155.023c0.441,7.278,0.329,11.56,4.001,15.298c5.524,5.623,14.51,2.298,16.252-4.964 c1.568-6.537,0.584-17.34-6.537-20.242C147.336,142.255,140.194,147.745,140.635,155.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M154.264,159.056c2.741-2.778,7.266-8.833,5.685-13.389c-2.333-6.722-9.278-4.445-8.167-3.111 c-4.037-2.639-12.083-2.764-10.389,0.778c-7.278,1-7.863,3.945-5.848,5.056c-5.18,4.944-4.93,10.055-1.002,9.667 c-2.983,3,2.517,8.944,8.684,11.778C145.338,164.333,156.579,163.329,154.264,159.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.073,161.694c-0.049,0-0.098-0.014-0.141-0.043c-0.114-0.078-0.144-0.233-0.066-0.347 c1.583-2.326,3.125-4.186,4.485-5.828c2.601-3.137,4.48-5.403,4.64-8.49c0.13-2.495-1.336-4.679-3.921-5.843 c-1.862-0.839-3.861-0.889-4.649-0.115c-0.419,0.411-0.458,1.023-0.118,1.819c0.055,0.127-0.004,0.273-0.131,0.328 c-0.127,0.053-0.274-0.004-0.328-0.132c-0.536-1.25-0.172-1.98,0.228-2.372c0.942-0.924,3.13-0.917,5.205,0.016 c2.779,1.253,4.355,3.617,4.215,6.325c-0.169,3.253-2.093,5.573-4.755,8.783c-1.354,1.633-2.888,3.483-4.456,5.79 C151.231,161.656,151.153,161.694,151.073,161.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F3E3B"
    },
    d: "M151.428,158.237c0.114,1.906,1,3.7,2.065,4.872c1.602,1.764,3.273,0.665,3.556-1.484 c0.255-1.934-0.271-5.183-2.229-6.156C152.89,154.512,151.297,156.057,151.428,158.237z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M153.016,245.108c0,0,2.48,49.524-2.348,70.501c-7.646,33.226-22.282,71.748-22.282,71.748 l-13.616-2.564c0,0,11.47-38.583,13.957-66.238c2.234-24.844-1.066-53.378-1.066-73.446 C136.814,245.108,153.016,245.108,153.016,245.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M149.332,259.78c1.022-1.932,2.95,3.82,4.31,11.2c0.04,10.18-0.18,21.76-1.07,31.57 C145.774,290,147.219,263.778,149.332,259.78z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C6BDB"
    },
    d: "M131.709,383.178c0.057,0.011-2.125,4.726-2.125,4.726l-15.76-3.077l1.713-4.746L131.709,383.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M166.955,245.108c0,0,11.065,46.901,11.844,69.304c0.874,25.125-7.895,84.388-7.895,84.388H158.46 c0,0-1.532-59.724-2.086-82.609c-0.604-24.949-15.248-71.083-15.248-71.083H166.955z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C6BDB"
    },
    d: "M173.299,393.843c0.057,0-0.702,5.167-0.702,5.167h-15.139l-0.409-4.611L173.299,393.843z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContributor);
export default __webpack_public_path__ + "static/media/contributor.ad38b6bdc70e5b42b0041383c21493d8.svg";
export { ForwardRef as ReactComponent };